export default {
    init() {
        this.needDecitionChangeInput();
    },

    needDecitionChangeInput() {
        let popUp = $('.edit-lots-popup');
        let originalAmount = 0;
        let itemClicked = null;
        const self = this;

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('edit-item')) {
                e.preventDefault();

                $('.popup-input').val($(e.target).attr('data-amount'));
                originalAmount = $(e.target).attr('data-amount');
                itemClicked = $(e.target);
                popUp.fadeIn(300);
                if ($(e.target).parents().eq(1).hasClass('quantity')) {
                    $('.edit-lots-popup .qty').show();
                    $('.edit-lots-popup .reg').hide();
                } else {
                    $('.edit-lots-popup .qty').hide();
                    $('.edit-lots-popup .reg').show();
                }
            }
        });

        $('body').on('mousedown', function (e) {
            if ($(e.target).hasClass('edit-lots-popup')) {
                popUp.fadeOut(300);
            }
        });

        $('.edit-lots-popup .close-pop').on('click', function (e) {
            e.preventDefault();
            popUp.fadeOut(300);
        });

        $('.edit-lots-popup .confirm').on('click', function (e) {
            e.preventDefault();
            let popUpVal = $('.popup-input').val();

            if (popUpVal !== originalAmount) {
                itemClicked.attr('data-amount', popUpVal);
                itemClicked.parent().find('.amount').html(popUpVal);
                if (itemClicked.parents().eq(4).hasClass('lots-list--item-row--log-list')) {
                    self.updatePackAfterChange(itemClicked.parents().eq(7));
                }
            }
            popUp.fadeOut(300);
        });
    },

}